export default "__VITE_ASSET__Bix54Pvq__"